import InputTextBox from "Components/common/InputTextBox";
import { observer } from "mobx-react";
import SingleSelectDropdown from "Pages/Dashboard/settings/Calendar/Pages/Events/CreateEvent/Components/SingleSelectDropdown";
import React, { useEffect, useState } from "react";
import { conditionsOperatorObject } from "Static/constant";
import { settingsStoreData } from "Stores/settingsData";
import userDetail from "Stores/userDetail";
import Utils from "Utils/utils";
import ActionButton from "./ActionButton";
import DropdownButton from "./DropdownButton";
import {
  booleanOptions,
  liConnectionReqOptions,
  liMsgOptions,
  textOperatorList
} from "./FilterConstants";
import SingleDropdown from "./SingleDropdown";

export const ContactMetricsFilter = observer(props => {
  const {
    label = "",
    keyValue = "",
    activeFilter = "",
    data = [],
    errMsg = "",
    setErrMsg = () => {},
    setActiveFilter = () => {},
    setAction = () => {},
    selectedFilterCbk = () => {},
    customConditionFieldnameList = [],
    singleFieldWithoutDropdown = false
  } = props || {};

  let toggleDropdown = activeFilter === keyValue;

  const [activeDropdownIndex, setActiveDropdownIndex] = useState(false);
  const [fieldNameObject, setFieldNameObject] = useState({});
  const disabledFeatureSet = new Set(userDetail?.featuresDisabled || []);

  const getConditionFieldsObject = () => {
    let tempObj = {};
    let tempArr = customConditionFieldnameList?.length
      ? customConditionFieldnameList
      : conditionFieldnameList;
    tempArr?.length > 0 &&
      [...tempArr].map(item => {
        tempObj[item?.key] = item?.value;
      });
    setFieldNameObject({ ...fieldNameObject, ...tempObj });
  };

  const validateFieldNameAlreadyExist = (newFieldName = "") => {
    let count = 0;
    if (data?.length > 1) {
      data.some(element => {
        if (element?.fieldName === newFieldName) {
          count++;
        }
      });
    }
    return !count > 0;
  };

  const handleAction = (refId = "", item = "", index = "") => {
    if (refId === "fieldName") {
      if (!validateFieldNameAlreadyExist(item?.key)) {
        return;
      }
      selectedFilterCbk("add", keyValue);
    }
    errMsg && setErrMsg();
    const { key = "", subKey = "", value = "" } = item || {};
    let tempData = [...data];
    tempData[index]["value"] = [
      "profileviewscount",
      "hasvisitedwebsite"
    ].includes(item?.key?.toLowerCase())
      ? "true"
      : ["linkedinconnectionrequest", "linkedinmessage"].includes(
          item?.key?.toLowerCase()
        )
      ? "Sent"
      : "";
    tempData[index][refId] = refId === "fieldName" ? key : subKey || "";
    tempData[index]["label"] = value || "";
    setActiveDropdownIndex(false);
    setAction(keyValue, tempData);
  };

  const setFilterData = (tempData = {}, value = "", index = "") => {
    if (keyValue?.toLowerCase() === "contacts") {
      tempData[index]["fieldName"] = "contactsCount";
      tempData[index]["label"] = "Number of Contacts";
    }
    tempData[index]["value"] = value || "";
    return tempData;
  };

  const handleInputAction = (id = "", value = "", index = "") => {
    errMsg && setErrMsg();
    let tempData = [...data];
    setAction(keyValue, setFilterData(tempData, value, index));
  };

  const getCustomOperatorList = (fieldName = "") => {
    if (fieldName?.toLowerCase() === "websitevisitedurl") {
      return [...textOperatorList].map(item => ({
        ...item,
        method: handleAction
      }));
    } else if (
      [
        "profileviewscount",
        "linkedinmessage",
        "linkedinconnectionrequest",
        "hasvisitedwebsite"
      ]?.includes(fieldName?.toLowerCase())
    ) {
      return operatorList?.slice(0, 1);
    } else {
      return operatorList;
    }
  };

  const operatorList = [
    {
      value: "<span class='conditionSymbol'>&equals;</span> (Equals)",
      subKey: "EQUALS",
      key: "equalCond",
      method: handleAction
    },
    {
      value: "<span class='conditionSymbol'>&gt;</span> (Greater than)",
      subKey: "GREATER_THAN",
      key: "greaterCond",
      method: handleAction
    },
    {
      value: "<span class='conditionSymbol'>&lt;</span> (Less than)",
      subKey: "LESS_THAN",
      key: "lesserCond",
      method: handleAction
    }
  ];

  const conditionFieldnameList = [
    {
      value: "Reply Count",
      subKey: "REPLIED",
      key: "replyCount",
      method: handleAction
    },
    {
      value: "Open Count",
      subKey: "OPENED",
      key: "openCount",
      method: handleAction
    },
    {
      value: "Click Count",
      subKey: "CLICKED",
      key: "clickCount",
      method: handleAction
    },
    {
      value: "Sent Count",
      subKey: "SENT",
      key: "sentCount",
      method: handleAction
    },
    {
      value: "Calls Made",
      subKey: "CALLMADE",
      key: "callsMade",
      method: handleAction
    },
    {
      value: "Calls Logged",
      subKey: "CALLLOGGED",
      key: "callsLogged",
      method: handleAction
    },
    {
      value: "Website Visit Count",
      subKey: "WEBSITEVISITEDCOUNT",
      key: "seqWebsiteVisitedCount",
      method: handleAction,
      featureTitle: "WEBSITE_TRACKING"
    },
    {
      value: "Has Visited Website",
      subKey: "HASVISITEDWEBSITE",
      key: "hasVisitedWebsite",
      method: handleAction,
      featureTitle: "WEBSITE_TRACKING"
    },
    {
      value: "Website Visit URL",
      subKey: "WEBSITEVISITEDURL",
      key: "seqWebsiteVisitedUrl",
      method: handleAction,
      featureTitle: "WEBSITE_TRACKING"
    },
    {
      value: "LinkedIn connection request",
      subKey: "LINKEDINCONNNECTIONREQUEST",
      key: "linkedInConnectionRequest",
      method: handleAction,
      featureTitle: "LINKEDIN_AUTOMATION"
    },
    {
      value: "LinkedIn message",
      subKey: "LINKEDINMESSAGE",
      key: "linkedInMessage",
      method: handleAction,
      featureTitle: "LINKEDIN_AUTOMATION"
    },
    {
      value: "LinkedIn profile viewed",
      subKey: "PROFILEVIEWSCOUNT",
      key: "profileviewscount",
      method: handleAction,
      featureTitle: "LINKEDIN_AUTOMATION"
    }
   // {
   //   value: "WhatsApp message",
   //   subKey: "WHATSAPPMESSAGE",
   //   key: "whatsappMessage",
   //   method: handleAction
   // }
  ];

  const getConditionFieldnameList = () => {
    if (!customConditionFieldnameList?.length) {
      return conditionFieldnameList.filter(item => {
        if (item?.featureTitle) {
          return !disabledFeatureSet.has(item.featureTitle);
        }
        return true;
      });
    } else {
      return customConditionFieldnameList.map(item => ({
        ...item,
        method: handleAction
      }));
    }
  };

  const resetOrAddNewItem = (isPush = false) => {
    let newObj = {
      fieldName: "",
      operator: "EQUALS",
      value: ""
    };
    if (isPush) {
      return newObj;
    }
    selectedFilterCbk("remove", keyValue);
    setAction(keyValue, [newObj]);
  };

  const removeItem = index => {
    let tempData = [...data];
    let len = tempData?.length;
    if (len) {
      if (len === 1) {
        resetOrAddNewItem();
      } else {
        tempData.splice(index, 1);
        tempData.filter(item => item?.fieldName)?.length < 1 &&
          selectedFilterCbk("remove", keyValue);
        setAction(keyValue, tempData);
      }
      errMsg && setErrMsg();
    }
  };

  const addItem = () => {
    let tempData = [...data];
    tempData.push(resetOrAddNewItem(true));
    errMsg && setErrMsg();
    setAction(keyValue, tempData);
  };

  const resetItem = () => {
    errMsg && setErrMsg();
    data?.filter(item => item?.fieldName)?.length && resetOrAddNewItem();
  };

  const dropdownOptions = {
    label: label,
    count: data?.filter(item => item?.fieldName)?.length || 0,
    keyValue: keyValue,
    toggleDropdown: toggleDropdown,
    callback: setActiveFilter
  };

  const getDropdownObj = fieldName => {
    return {
      name: `${fieldName} Dropdown`,
      id: fieldName,
      type: "select",
      options: ["hasvisitedwebsite", "profileviewscount"].includes(
        fieldName?.toLowerCase()
      )
        ? [...booleanOptions]
        : fieldName?.toLowerCase() === "linkedinconnectionrequest"
        ? [...liConnectionReqOptions]
        : [...liMsgOptions],
      text: `${fieldName} Dropdown`,
      showLabel: false
    };
  };

  const filterFn = Utils.getFilterFn("CONTACT_METRICS_FILTER");

  useEffect(() => {
    getConditionFieldsObject();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [settingsStoreData?.customFields]);

  return (
    <div className="conditionField">
      <DropdownButton {...dropdownOptions} />
      {toggleDropdown && (
        <div className="dropdownSearchBox">
          <span className="horizontalBorderLine" />
          {(data?.length && (
            <div className="conditionalFieldCard">
              {data.map((item, index) => {
                const {
                  fieldName = "",
                  operator = "EQUALS",
                  value = ""
                } = item || {};

                const hasSingleDropdownWithBoolValue = [
                  "profileviewscount",
                  "linkedinmessage",
                  "linkedinconnectionrequest",
                  "hasvisitedwebsite"
                ].includes(fieldName?.toLowerCase());

                const conditionalFieldProps = {
                  isDropdownAllowed: true,
                  options: getConditionFieldnameList(),
                  defaultValue: fieldNameObject?.[fieldName] || "",
                  label: "Select field",
                  referenceId: "fieldName",
                  parentIndex: index,
                  hasCustomFieldValue: true,
                  showDropdown: activeDropdownIndex === `fieldName-${index}`,
                  setActiveDropdownIndex: setActiveDropdownIndex
                };

                const fieldOperatorProps = {
                  isDropdownAllowed: true,
                  options: getCustomOperatorList(fieldName),
                  defaultValue: hasSingleDropdownWithBoolValue
                    ? conditionsOperatorObject?.["EQUALS"]
                    : conditionsOperatorObject?.[operator] || "",
                  showDropdown:
                    !hasSingleDropdownWithBoolValue &&
                    activeDropdownIndex === `operator-${index}`,
                  setActiveDropdownIndex: setActiveDropdownIndex,
                  parentIndex: index,
                  referenceId: "operator"
                };

                const inputProps = {
                  name: "number",
                  type: hasSingleDropdownWithBoolValue ? "text" : "number",
                  value: value,
                  change: handleInputAction,
                  parentIndex: index,
                  placeHolder: "Value"
                };
                const dropDownObj = getDropdownObj(fieldName);

                return (
                  <div
                    className="conditionalField"
                    key={`conditionalField${index}`}
                  >
                    {!singleFieldWithoutDropdown && (
                      <div className="fieldnameDropdown">
                        <SingleDropdown
                          {...conditionalFieldProps}
                          search={true}
                          customDropdownClassName="bottomDropdown"
                          filterFn={filterFn}
                        />
                        <i
                          className="material-icons-outlined deleteIcon"
                          onClick={() => removeItem(index)}
                        >
                          delete
                        </i>
                      </div>
                    )}
                    {(fieldName || singleFieldWithoutDropdown) && (
                      <div
                        className={`fieldOperatorValue ${
                          !fieldName && !singleFieldWithoutDropdown
                            ? "disableInput"
                            : ""
                        }`}
                      >
                        <SingleDropdown {...fieldOperatorProps} />
                        {!hasSingleDropdownWithBoolValue ? (
                          <InputTextBox {...inputProps} />
                        ) : (
                          <SingleSelectDropdown
                            {...dropDownObj}
                            change={(param1, param2) => {
                              handleInputAction(param1, param2, index);
                            }}
                            value={value || dropDownObj?.options?.[0] || ""}
                            key={fieldName}
                            displayName="displayName"
                            timezone={true}
                          />
                        )}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          )) ||
            ""}
          {!singleFieldWithoutDropdown && (
            <ActionButton resetCbk={resetItem} addCbk={addItem} />
          )}
          {errMsg === keyValue && (
            <span className="errMessage">Please enter a value</span>
          )}
        </div>
      )}
    </div>
  );
});

export default ContactMetricsFilter;
